
import { Treatment, PracticeLocation, SiteSettings } from '../types';
import { INITIAL_TREATMENTS, INITIAL_LOCATIONS, INITIAL_SETTINGS, INITIAL_CATEGORIES } from '../constants';

const KEYS = {
  TREATMENTS: 'md_clinic_data_treatments',
  LOCATIONS: 'md_clinic_data_locations',
  SETTINGS: 'md_clinic_data_settings',
  CATEGORIES: 'md_clinic_data_categories'
};

export const storageService = {
  get: <T>(key: string, defaultValue: T): T => {
    try {
      const data = localStorage.getItem(key);
      if (!data) return defaultValue;
      return JSON.parse(data) as T;
    } catch (e) {
      console.error(`Error reading ${key}:`, e);
      return defaultValue;
    }
  },

  set: (key: string, data: any): void => {
    localStorage.setItem(key, JSON.stringify(data));
  },

  saveAll: (data: any) => {
    storageService.set(KEYS.TREATMENTS, data.treatments);
    storageService.set(KEYS.LOCATIONS, data.locations);
    storageService.set(KEYS.SETTINGS, data.settings);
    storageService.set(KEYS.CATEGORIES, data.categories);
    window.dispatchEvent(new Event('storage_sync'));
  },

  getAllData: () => ({
    treatments: storageService.get<Treatment[]>(KEYS.TREATMENTS, INITIAL_TREATMENTS),
    locations: storageService.get<PracticeLocation[]>(KEYS.LOCATIONS, INITIAL_LOCATIONS),
    settings: storageService.get<SiteSettings>(KEYS.SETTINGS, INITIAL_SETTINGS),
    categories: storageService.get<string[]>(KEYS.CATEGORIES, INITIAL_CATEGORIES)
  }),

  updateCategories: (newCategories: string[], treatments: Treatment[]) => {
    storageService.set(KEYS.CATEGORIES, newCategories);
    storageService.set(KEYS.TREATMENTS, treatments);
    window.dispatchEvent(new Event('storage_sync'));
  },

  saveTreatments: (t: Treatment[]) => storageService.set(KEYS.TREATMENTS, t),
  saveLocations: (l: PracticeLocation[]) => storageService.set(KEYS.LOCATIONS, l),
  saveSettings: (s: SiteSettings) => storageService.set(KEYS.SETTINGS, s),
  saveCategories: (c: string[]) => storageService.set(KEYS.CATEGORIES, c)
};
